function getBundleInfo(filepath, id) {
    $.ajax({
        url: "/bundleInfo",
        type: 'post',
        data: {
            filepath: filepath,
            id: id
        },
        dataType: 'JSON',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response){
            openBuyModal(response.data);
        }
    });
}
function openBuyModal(json) {
    let allContents = $('#sub-modal .content');
    let standardContent = $('#sub-modal .content-standard');
    let featureContent = $('#sub-modal .content-feature');
    let standardCounter = 0;
    let featureCounter = 0;

    // Clear old contents
    allContents.each(function() {
        $(this).addClass('d-none');
    });
    for (let i=0; i<json.length; i++) {
        if (json[i].is_feature) {
            popupHelper(featureContent, featureCounter, json, i);

            $(featureContent[featureCounter]).find(".bundle-cover").attr('src',json[json.length -1]['cdn'] + '/universe/programs/' + json[i]['is_feature'] + '/splash.jpg');
            $(featureContent[featureCounter]).removeClass('d-none');

            // if program. checks ID because 4-digit IDs are programs
            if (json[i]['id'].toString().length == 4) {
                $(featureContent[featureCounter]).find(".bundle-buy-button").text('+ ADD PROGRAM');
            }

            featureCounter += 1;
        }
        else {
            popupHelper(standardContent, standardCounter, json, i);

            let numCovers = Math.min(json[i]['content'].length, 8);

            // Hide old covers in case there are less than 8...this should have been obvious. Maybe bubbles too? Frick maybe refactor. Frick frick frick
            $(standardContent[standardCounter]).find(".bundle-covers-container").children().map(function() {
                $(this).find('img').addClass('d-none');
                $(this).find()
                $(this).find('.bubbles').find('.bubble').map(function() {
                    $(this).addClass('d-none');
                });
            });

            $(standardContent[standardCounter]).find(".bundle-covers-container").children().slice(0,numCovers).map(function(x) {
                let tempFilepath = json[i]['content'][x].replace("/*", "");

                $(this).find('img').attr('src', json[i]['cdn'] + '/universe/' + tempFilepath + '/cover.jpg');
                $(this).find('img').removeClass('d-none');

                let bubColors = json[i]['bubbles'][x].split('/');
                for (let j=0; j<bubColors.length; j++) {
                    $(this).find('.bubble-' + bubColors[j]).removeClass('d-none');
                }

                $(this).removeClass('d-none');
            });

            $(standardContent[standardCounter]).removeClass('d-none');

            standardCounter += 1;
        }
    }

    // Prevent horrible shifting hopefully...
    // $('body, html').css({
    //     'overflow-y' : 'hidden',
    //     height: '100%'
    // });
    $("#sub-modal").modal('show');

}
function popupHelper(contentType, counter, json, i) {
    $(contentType[counter]).find(".bundle-name").html(json[i]['name']);
            $(contentType[counter]).find(".bundle-blurb").html(json[i]['blurb']);

            if (json[i]['interval_count'] > 1) {
                $(contentType[counter]).find(".bundle-price").html(prettifyMoney(json[i]['price']) + ' / ' + json[i]['interval_count'] + ' ' + json[i]['interval'] + "s");
            }
            else {
                $(contentType[counter]).find(".bundle-price").html(prettifyMoney(json[i]['price']) + ' / ' + json[i]['interval']);
            }


            $(contentType[counter]).find(".bundle-buy-button").on('click', function(){
                let me = this;
                addToCart(json[i]['id']).done(function(response) {
                    $(me).addClass('d-none');
                    $(me).next().removeClass('d-none');
                    updateCartIcon();

                    reportToFacebook(json[i]);
                });
            });

            // Controls button, if added, disable.
            // Easy to bypass but like, f u? Like do you REALLY
            // Need to add it twice? Okay pay twice for something LOL
            // ¯\_(ツ)_/¯
            if (json[i]['in_cart'] || json[i]['is_owned']) {
                $(contentType[counter]).find(".bundle-buy-button").addClass('d-none');
                $(contentType[counter]).find(".bundle-buy-button").next().removeClass('d-none');
                if (json[i]['in_cart']) {
                    $(contentType[counter]).find(".bundle-buy-button").next().text('Already in your cart!');
                }
                else {
                    $(contentType[counter]).find(".bundle-buy-button").next().text('Already owned!');
                }
            }
            else {
                $(contentType[counter]).find(".bundle-buy-button").removeClass('d-none');
                $(contentType[counter]).find(".bundle-buy-button").next().addClass('d-none');
            }
}
function addToCart(x) {
    return $.ajax({
        url: "/addToCart",
        type: 'post',
        data: {id: x},
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: "json",
    });
}
function removeFromCart(x) {
    // Not being used...
    // // $("#bundle-" + x).addClass('d-none');
    // $.ajax({
    //     url: "/removeFromCart",
    //     type: 'post',
    //     data: {id: x},
    //     headers: {
    //         'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    //     },
    //     dataType: "json",
    //     success: function(response){
    //         if (response.status == "success") {
    //             // $("#cart-quantity").html(response.cart_quantity);
    //             if(response.cart_quantity == 0) {
    //                 // $("#empty-cart").removeClass('d-none');
    //                 // $("#full-cart").addClass('d-none');
    //                 console.log("worked");
    //             }
    //         }
    //     }
    // });
    // location.reload();
}
function openCart() {
    $.ajax({
        url: "/getCart",
        type: 'post',
        // data: {id: x},
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response){
        }
    });
}
function emptyCart() {
    $.ajax({
        url: "/emptyCart",
        type: 'post',
        // data: {id: x},
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response){
        }
    });
}
function lineItems() {
    $.ajax({
        url: "/lineItems",
        type: 'post',
        // data: {id: x},
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response){
        }
    });
}
function updateCartIcon() {
    console.log("updating cart icon");
    $.ajax({
        url: "/getCartQuantity",
        type: 'post',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response){
            $('.cart-quantity').each(function() {
                $(this).html(response);
            });
            $("#cart-quantity").html(response);
        },
    });
}
function openPasswordResetModal(){
    $("#password-reset-modal").modal('show');
}
function bindBundleModalButtons(){
    $('#cart-items').find('i').each(function() {
        let id = $(this).next().val();
        $(this).on('click', function(){
            // prepPopup(id).done(function(response) {
            //     openBuyModal(response, response.isProgram);
            // });
            getBundleInfo(undefined, id);
        });
    });
}
function reportToFacebook(json) {
    console.log("currently snitching to fb");

    fbq('track', 'AddToCart', {
        content_name: json['name'],
        content_ids: [json['stripe_id']],
        value: parseFloat(json['price'])/100.0,
        currency: 'USD'
    });
}
// At the top of the page :+1:
$(function() {
    updateCartIcon();
    bindBundleModalButtons();
});

window.getBundleInfo = getBundleInfo;
window.openBuyModal = openBuyModal;
// window.popupHelper = popupHelper;
window.addToCart = addToCart;
window.removeFromCart = removeFromCart;
window.openCart = openCart;
window.emptyCart = emptyCart;
window.lineItems = lineItems;
window.updateCartIcon = updateCartIcon;
window.openPasswordResetModal = openPasswordResetModal;
window.bindBundleModalButtons = bindBundleModalButtons;
window.reportToFacebook = reportToFacebook;
